export default {
      id: "ic_msg-usage",
      viewBox: "0 0 960 960",
      url: __webpack_public_path__ + "img/icons.svg#ic_msg",
      toString: function () {
        return this.url;
      }
    }